import type React from 'react';

import { Card, CardBody, Text } from '@change/ds-core-ui';

import { TypedTranslate } from '@change-corgi/core-react/i18n';

import { IconTile } from '#src/app/pages/about/shared/components';

import type { SupporterActionType } from '../../consts';

export const SupporterTile: React.FC<SupporterActionType> = ({ Icon, title, body }) => {
	return (
		<Card className="bg-background-base rounded-2xl">
			<CardBody>
				<div className="flex items-center gap-4" data-qa="vision-supporter-row">
					<IconTile Icon={Icon} size="small" data-qa="vision-supporter-icon-tile" />
					<div className="flex min-w-0 flex-col gap-0.5">
						<Text as="h3" variant="heading" size="xx-small">
							<TypedTranslate value={title} />
						</Text>
						<Text as="p" size="small" className="text-typography-weak">
							<TypedTranslate value={body} />
						</Text>
					</div>
				</div>
			</CardBody>
		</Card>
	);
};
